import axios from 'axios';
import { useQuery } from 'react-query';
import { environment } from '../config/environment';
import { KeyedObject } from '../abelcommon';

export const fetchSearchResult = (keywords: string) =>
  axios
    .get(`${environment.apiBase}/search?keyword=${keywords}`)
    .then((res) => res.data);

export const useSearchResult = (keywords: string, options?: KeyedObject) => {
  return useQuery(['search-result', keywords], () => fetchSearchResult(keywords), {
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options,
  });
};

export default useSearchResult;
